var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"oct-popover",class:{ 'oct-popover--open': _vm.isOpen },style:({
    top: _vm.$data.$_octPopover_position.top + 'px',
    left: _vm.$data.$_octPopover_position.left + 'px'
  }),attrs:{"id":_vm.id}},[_c('div',{staticClass:"oct-popover__content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }